export default __webpack_public_path__ + "static/media/hotel-resort-img-21.5ada7aff.jpg";